import Container from './StudioTableHeader.container';
import StudioTableHeader from './StudioTableHeader';

export default Container(StudioTableHeader);
